<div class="dialog-header flex row justify-space-between">
	<h1 mat-dialog-title i18n="Visibility Conditions Dialog Title@@VisibilityConditionsDialogTitle">
		Visibility conditions for {{ data.name }}
	</h1>
	<mat-icon [mat-dialog-close]="null" class="cursor-pointer">close</mat-icon>
</div>

<div mat-dialog-content class="visibility-conditions-dialog">
	<mat-tab-group #matTabGroup mat-stretch-tabs anchorSelectedTab (selectedTabChange)="onTabChange($event)" animationDuration="0ms">
		<mat-tab label="Builder" i18n-label="Visibility Condition Builder Tab Label@@VisibilityConditionBuilderTabLabel">
			<div class="mt-6">
				<span
					*ngIf="!conditions"
					class="text-center"
					i18n="Visibility Condition No Conditions Subtitle@@VisibilityConditionNoConditionsSubtitle"
					>No conditions defined. Click the 'Add Group' button to start.</span
				>
				<app-recursive-condition-group
					[group]="conditions"
					[mergeTagState]="data.mergeTagState"
					(setRootGroup)="setRootCondition($event)"
					(onChange)="onChange()"
				></app-recursive-condition-group>
			</div>
			<span
				*ngIf="!isValid"
				class="mat-error mt-2"
				i18n="Visibility Condition Invalid Configuration@@VisibilityConditionInvalidConfiguration"
				>The configuration is not valid.</span
			>
		</mat-tab>
		<mat-tab label="Code" i18n-label="Visibility Condition Code Tab Label@@VisibilityConditionCodeTabLabel">
			<div>
				<div class="flex mt-5 mb-2 clipboard-buttons-gap">
					<button 
						mat-flat-button 
						class="mat-tertiary" 
						i18n="Dialog Action Button Paste@@dialogActionButtonPasteFromClipboardLabel"
						(click)="btnPasteFromClipboardClick()"
					>
						Paste from clipboard
					</button>
					<button 
						mat-flat-button 
						class="mat-tertiary" 
						i18n="Dialog Action Button Copy@@dialogActionButtonCopyToClipboardLabel"
						(click)="btnCopyToClipboardClick()"
					>
						Copy to Clipboard
					</button>
				</div>
				<app-monaco-input
					#jsonEditor
					[currentValue]="jsonValue"
					language="json"
					(valueChange)="onUpdateJSONValue($event)"
				></app-monaco-input>
				<span
					*ngIf="!isValid"
					class="mat-error mt-2"
					i18n="Visibility Condition Invalid JSON Configuration@@VisibilityConditionInvalidJSONConfiguration"
					>The JSON configuration is not valid.</span
				>
			</div>
		</mat-tab>
	</mat-tab-group>
</div>

<div mat-dialog-actions class="dialog-actions">
	<div class="flex right">
		<button class="cancel" mat-flat-button [mat-dialog-close]="null" i18n="Dialog Action Button@@dialogActionButtonCancelLabel">
			Cancel
		</button>
		<button
			mat-flat-button
			(click)="save()"
			[disabled]="!isValid"
			color="primary"
			class="button-extra-small"
			i18n="Dialog Action Button@@dialogActionButtonSaveLabel"
		>
			Save
		</button>
	</div>
</div>
